import store from "@/store";

import createAuth from "@/router/guards/auth";
import createAuthz from "@/router/guards/authz";
import createResolve from "@/router/guards/resolve";
import saveScrollPosition from "@/router/guards/position";

export const auth = createAuth(store);
export const authz = createAuthz(store);
export const resolve = createResolve(store);
export { saveScrollPosition };
